import React, { useEffect, useState } from 'react'
import Menu from '../Menu/Menu'
import { Outlet, Link } from "react-router-dom";
import './TravelsEnd.min.css'
import axios from "axios";
import TravelFinished from './TravelFinished';
import { ipAddress } from '../../ipAddress';

interface TravelEnd {
  id: number;
  city: string;
  date: string;
  dateEnd: string;
  isDone: number;
}


const TravelsEnd: React.FC = () => {

  const [travelsEnd, setTravelsEnd] = useState<TravelEnd[]>([])

  const registerUser = () => {
    axios.get(ipAddress + "/getTravelEnd")
      .then((response) => {
        setTravelsEnd(response.data)

      }
      )

      .catch(function (error) {
        console.log("error!")

      })
  }

  useEffect(() => {
    registerUser();
  }, [travelsEnd])





  return (
    <div>
      <Menu />
      <div className='travel2'>
        <Link to='../'>Zaplanowane</Link>
        <Link to='Zakonczone'>Zakończone</Link>
      </div>
      <div>
        {travelsEnd.map((travelEnd) => (
          <TravelFinished travelEnd={travelEnd} key={travelEnd.id}
            travelsEnd={travelsEnd} setTravelsEnd={setTravelsEnd}
          />
        ))}

      </div>
      <Outlet />
    </div>
  )
}

export default TravelsEnd